export var TransactionStatusType;
(function (TransactionStatusType) {
    TransactionStatusType["PENDING"] = "PENDING";
    TransactionStatusType["SUCCEEDED"] = "SUCCEEDED";
    TransactionStatusType["REJECTED"] = "REJECTED";
    TransactionStatusType["PROCESSING"] = "PROCESSING";
    TransactionStatusType["PENDING_MANUAL_REVIEW"] = "PENDING_MANUAL_REVIEW";
    TransactionStatusType["DRAFT"] = "DRAFT";
})(TransactionStatusType || (TransactionStatusType = {}));
export var BybitOrderStatuses;
(function (BybitOrderStatuses) {
    BybitOrderStatuses["REJECTED"] = "REJECTED";
    BybitOrderStatuses["PARTIALLY_FILLED_CANCELED"] = "PARTIALLY_FILLED_CANCELED";
    BybitOrderStatuses["FILLED"] = "FILLED";
    BybitOrderStatuses["CANCELLED"] = "CANCELLED";
    BybitOrderStatuses["TRIGGERED"] = "TRIGGERED";
    BybitOrderStatuses["DEACTIVATED"] = "DEACTIVATED";
    BybitOrderStatuses["NEW"] = "NEW";
    BybitOrderStatuses["PARTIALLY_FILLED"] = "PARTIALLY_FILLED";
    BybitOrderStatuses["UNTRIGGERED"] = "UNTRIGGERED";
    BybitOrderStatuses["CREATED"] = "CREATED";
})(BybitOrderStatuses || (BybitOrderStatuses = {}));
export var KrakenOrderStatuses;
(function (KrakenOrderStatuses) {
    KrakenOrderStatuses["PENDING"] = "PENDING";
    KrakenOrderStatuses["OPEN"] = "OPEN";
    KrakenOrderStatuses["CLOSED"] = "CLOSED";
    KrakenOrderStatuses["CANCELED"] = "CANCELED";
    KrakenOrderStatuses["EXPIRED"] = "EXPIRED";
    KrakenOrderStatuses["FAILED"] = "FAILED";
})(KrakenOrderStatuses || (KrakenOrderStatuses = {}));
export var SwapSubStatuses;
(function (SwapSubStatuses) {
    SwapSubStatuses["DRAFT"] = "DRAFT";
    SwapSubStatuses["DEPOSIT_PENDING"] = "DEPOSIT_PENDING";
    SwapSubStatuses["DEPOSIT_CONFIRMED"] = "DEPOSIT_CONFIRMED";
    SwapSubStatuses["DEPOSIT_FAILED"] = "DEPOSIT_FAILED";
    SwapSubStatuses["BLOCKED"] = "BLOCKED";
    SwapSubStatuses["DEPOSIT_REBALANCING_PENDING"] = "DEPOSIT_REBALANCING_PENDING";
    SwapSubStatuses["DEPOSIT_REBALANCING_FAILED"] = "DEPOSIT_REBALANCING_FAILED";
    SwapSubStatuses["DEPOSIT_REBALANCING_CONFIRMED"] = "DEPOSIT_REBALANCING_CONFIRMED";
    SwapSubStatuses["LIQUIDATION_PENDING"] = "LIQUIDATION_PENDING";
    SwapSubStatuses["LIQUIDATION_FAILED"] = "LIQUIDATION_FAILED";
    SwapSubStatuses["LIQUIDATION_CONFIRMED"] = "LIQUIDATION_CONFIRMED";
    SwapSubStatuses["EXCHANGE_IN_PROGRESS"] = "EXCHANGE_IN_PROGRESS";
    SwapSubStatuses["EXCHANGE_COMPLETED"] = "EXCHANGE_COMPLETED";
    SwapSubStatuses["EXCHANGE_FAILED"] = "EXCHANGE_FAILED";
    SwapSubStatuses["WITHDRAW_INTERNAL_REBALANCING_TRANSFER_PENDING"] = "WITHDRAW_INTERNAL_REBALANCING_TRANSFER_PENDING";
    SwapSubStatuses["WITHDRAW_INTERNAL_REBALANCING_TRANSFER_FAILED"] = "WITHDRAW_INTERNAL_REBALANCING_TRANSFER_FAILED";
    SwapSubStatuses["WITHDRAW_INTERNAL_REBALANCING_TRANSFER_CONFIRMED"] = "WITHDRAW_INTERNAL_REBALANCING_TRANSFER_CONFIRMED";
    SwapSubStatuses["WITHDRAW_REBALANCING_PENDING"] = "WITHDRAW_REBALANCING_PENDING";
    SwapSubStatuses["WITHDRAW_REBALANCING_FAILED"] = "WITHDRAW_REBALANCING_FAILED";
    SwapSubStatuses["WITHDRAW_REBALANCING_CONFIRMED"] = "WITHDRAW_REBALANCING_CONFIRMED";
    SwapSubStatuses["WITHDRAW_IN_PROGRESS"] = "WITHDRAW_IN_PROGRESS";
    SwapSubStatuses["WITHDRAW_COMPLETED"] = "WITHDRAW_COMPLETED";
    SwapSubStatuses["WITHDRAW_FAILED"] = "WITHDRAW_FAILED";
})(SwapSubStatuses || (SwapSubStatuses = {}));
//# sourceMappingURL=status.js.map